import { render, staticRenderFns } from "./Accept.vue?vue&type=template&id=2498f5a5&scoped=true&"
import script from "./Accept.vue?vue&type=script&lang=js&"
export * from "./Accept.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2498f5a5",
  null
  
)

export default component.exports